import { SeDateTimeString, SeDateTimeOptions } from './date-time-types'
import { SeRangeFormatter } from './range-formatter'
import { SeDateFormatter } from './date-formatter'
import { SeDate } from './date'
import { extendClass } from './extend-class'

export class SeDateRange {

  constructor(
    startValue: SeDateTimeString,
    endValue: SeDateTimeString,
    options: SeDateTimeOptions
  ) {
    this.initDate(startValue, options)
    this.initRange(startValue, endValue, options, SeDate)
  }

}

export interface SeDateRange extends SeDateFormatter, SeRangeFormatter<SeDate> {}
extendClass(SeDateRange, SeDateFormatter, SeRangeFormatter)
